import styled from 'styled-components';
import { Colors, Spacing } from 'web-common/src/shared/styles';

export const ScrollablePaneFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  background: white;
  border-top: 1px solid ${Colors.GRAY_LITE_10};
  padding: ${Spacing.THREE_QUARTERS};
  padding-bottom: max(env(safe-area-inset-bottom), ${Spacing.THREE_QUARTERS}); // NOTE: Safe margin for mobile

  z-index: 1000;

  // Mobile footer should only display on small screens
  @media (min-width: 992px) and (max-width: 1199px) {
    display: none;
  }
`;
